import React, { useEffect, useState } from 'react';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container, { Number } from './styles';
import postWishlist from '../../packages/api/postWishlist';
import deleteWishlist from '../../packages/api/deleteWishlist';

const Character = ({ villagerId, name, image, liked, className }) => {
  const [theImage, setTheImage] = useState('');
  const [isLiked, setIsLiked] = useState(liked);
  const number = 0;

  useEffect(() => {
    setTheImage(encodeURIComponent(image));
  }, []);

  const handleClick = () => {
    console.log("Handle like : " + villagerId)
    if (isLiked) {
      const payload = { data: { villager: villagerId } };
      deleteWishlist(payload);
      setIsLiked(false);
    }
    if (!isLiked) {
      const payload = { villager: villagerId };
      postWishlist(payload);
      setIsLiked(true);
    }
  };

  return (
    <Container className={className}>
      {isLiked ? (
        <FavoriteIcon
          style={{ color: 'hsl(0, 79%, 72%)', cursor: 'pointer' }}
          onClick={handleClick}
        />
      ) : (
        <FavoriteBorderIcon
          style={{ color: 'hsl(0, 79%, 72%)', cursor: 'pointer' }}
          onClick={handleClick}
        />
      )}
      <div aria-hidden="true">
        <div>
          <img
            src={`/Villageois/${theImage}`}
            alt={name}
            width="44px"
            height="44px"
          />
          <span>{name}</span>
        </div>
        <Number number={number}>{number}</Number>
      </div>
    </Container>
  );
};

Character.propTypes = {
  villagerId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  liked: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};

export default styled(Character)``;
